document.addEventListener('DOMContentLoaded', ()=>{
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  const mediaThumbEl = document.querySelector('.type__product_thumb_swiper.swiper');
  if (mediaThumbEl){
    var MediaThumbnailView = new Swiper('.type__product_thumb_swiper.swiper', {spaceBetween:12,slidesPerView:'auto',watchSlidesProgress: true});
  }
  const mediaEl = document.querySelector('.type__product_main_swiper.swiper');
  if (mediaEl){
    const mediaConfig = {spaceBetween:0,slidesPerView:1,pagination:{el:'.swiper-pagination',type:'progressbar'},navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },thumbs: {swiper: MediaThumbnailView} };
    new Swiper(mediaEl, mediaConfig);
  }

  const testimonialEl = document.querySelector('.Testimonial__reviews_interior.swiper');
  if (testimonialEl) {
    const testimonialConfig = { spaceBetween: 12, slidesPerView: 'auto', grabCursor: true };
    if (!isIOS) {
      testimonialConfig.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
      testimonialConfig.freeMode = true;
    }
    new Swiper(testimonialEl, testimonialConfig);
  }

  class PurchaseSelection extends HTMLElement {
    constructor() {
      super();
      this.attachEvents();
    }
    attachEvents() {
      ['Size-onetime'].forEach(name => {
        this.querySelectorAll(`input[name="${name}"]`).forEach(input => {
          input.addEventListener('change', () => {
            name === 'Size-onetime' ? this.syncVariantsOneTime() : '';
          });
        });
      });
  
      const addBtn = this.querySelector('.product-form__submit[name="add"]');
      if (addBtn) {
        addBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.productAddingCartOneTime()
        });
      }
    }
    syncVariantsOneTime() {
      this.selectedValueOnetime();
      this.selectMasterVariant(this.choosedOneTime);
      this.UpdateAppearance('onetime');
    }
    selectedValueOnetime() {
      this.choosedOneTime = [...this.querySelectorAll('input[name="Size-onetime"]:checked')].map(input => input.value);
    }
    getVariantData() {
      return this.variantData ||= JSON.parse(this.querySelector('[type="application/json"]').textContent);
    }
    selectMasterVariant(choices) {
      this.currentVariant = this.getVariantData().find(variant =>
        !variant.options.some((opt, idx) => opt !== choices[idx])
      );
    }
    UpdateAppearance(type) {

      const submitBtns = this.querySelectorAll(`.product-form__submit[type="submit"]`);
      const price = (value) => (value / 100).toFixed(2);

      const formatPriceString = (priceString) => {
          if (priceString.endsWith('.00')) {
              return priceString.slice(0, -3); 
          }
          return priceString;
      };
            
      if (!this.currentVariant) return;

      const comparePriceRaw = (this.currentVariant.compare_at_price ? this.currentVariant.compare_at_price : this.currentVariant.price);
      const priceRaw = this.currentVariant.price;
      let basePrice = 0,basePriceBeforeDiscount = 0,discountEl = 0,finalPriceEL = 0,basePriceAfterDiscount = 0,hasDiscount,fnlCp;

      discountEl = this.querySelector(`.shouldUsed__fordiscountv [data-variant-name="${this.currentVariant.title}"]`).dataset.discount;
      if(discountEl){
        basePriceBeforeDiscount = price(comparePriceRaw);
        finalPriceEL = basePriceBeforeDiscount - discountEl; 
        basePriceAfterDiscount = finalPriceEL.toFixed(2);
        hasDiscount = comparePriceRaw && priceRaw > basePriceAfterDiscount;
      }else{
        basePriceAfterDiscount = price(priceRaw);
        hasDiscount = comparePriceRaw && comparePriceRaw > priceRaw
      }

      basePrice = formatPriceString(basePriceAfterDiscount);

      const comparePriceRawString = price(comparePriceRaw);
      const comparePrice = hasDiscount ? formatPriceString(comparePriceRawString) : null; 
      
      const isAvailable = this.currentVariant.available;
      const soldOut = !isAvailable;
      const btnText = soldOut ? (hasDiscount ? `Sold Out — $${basePrice}&nbsp;<s>$${comparePrice}</s>` : `Sold Out — $${basePrice}`)  : (hasDiscount ? `Add to Cart — $${basePrice}&nbsp;<s>$${comparePrice}</s>` : `Add to Cart — $${basePrice}`);
      [...submitBtns].forEach(btn => {
        const label = btn.querySelector('.btn_txt_wp');
        if (label) label.innerHTML = btnText;
        btn.disabled = soldOut;
      });
      this.querySelector('[name="id"]').value = this.currentVariant.id;
    }
    productAddingCartOneTime() {
      this.handleAddToCart({
        id: this.querySelector('[name="id"]').value,
        quantity: 1,
      });
    }
    handleAddToCart(item) {
      const submitBtn = this.querySelector('.product-form__submit[name="add"]');
      submitBtn.classList.add('loading');
      submitBtn.disabled = true;
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) cartDrawer.enableLoading();
      const bundleCart = {
        items: [item],
        sections: cartDrawer?.getSectionsToRender()?.map(s => s.section) || [],
        sections_url: window.location.pathname
      };
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(bundleCart),
        credentials: 'same-origin'
      }).then(res => res.json())
        .then(data => cartDrawer?.renderContent(data.sections))
        .catch(console.error)
        .finally(() => {
          if (cartDrawer) {
            cartDrawer.disableLoading();
            cartDrawer.open();
          }
          submitBtn.classList.remove('loading');
          submitBtn.disabled = false;
        });
    }
  }
  customElements.define('cus-selection-variants', PurchaseSelection);

  if ( document?.querySelectorAll('.rainforest__bundle__include_overlay')?.length > 0 ){
    document.querySelector('.rainforest__bundle__include_overlay span').addEventListener('click', (target)=>{
        target.preventDefault();
        target.target.closest('.rainforest__bundle_includes_interior').querySelectorAll('.rainforest__bundle_include_container').forEach((el)=>{el.classList.remove('hidden')});
        target.target.closest('.rainforest__bundle_includes_interior').querySelector('.rainforest__bundle__include_overlay').classList.add('hidden');
    });    
  }

  if ( document?.querySelectorAll('.table__standards__chart__brief_swp.swiper')?.length > 0 ){
    document?.querySelectorAll('.table__standards__chart__brief_swp.swiper')?.forEach((swiperinitilize , index) => {
      new Swiper(swiperinitilize, {
        slidesPerView: 'auto',spaceBetween: 8,
        pagination: { el: `.tb_nav_control-${index} .swiper-pagination.pagination_table_chart`, clickable: true },
        navigation: { nextEl: `.tb_nav_control-${index} .swiper-button-next.next_table_chart`, prevEl: `.tb_nav_control-${index} .swiper-button-prev.prev_table_chart` }         
      });
    }); 
  }  

  if ( document?.querySelectorAll('.table__standards__tab_name').length > 0 ){
    document?.querySelectorAll('.table__standards__tab_name').forEach((el)=>{
      el.addEventListener('click', (target)=>{
        target.preventDefault();
        let tableIndex = target.currentTarget.dataset.tableIndex;
        document.querySelectorAll(`.table__standards__content_wp`).forEach((tb)=>{tb.classList.remove('active')});
        document.querySelectorAll(`.table__standards__tab_name`).forEach((tb)=>{tb.classList.remove('active')});
        target.currentTarget.classList.add('active');
        document.querySelector(`.table__standards__content_wp[data-table-content="${tableIndex}"]`).classList.add('active');
      })
    })
  }

  if ( document?.querySelectorAll('[js-initiate-cart]').length > 0 ){
    document?.querySelectorAll('[js-initiate-cart]').forEach((el)=>{
      el.addEventListener('click', (target)=>{
        target.preventDefault();
        const submitBtnInitiate = target.target.closest('.custom-product-form-xt').querySelector('.product-form__submit[name="add"]');
        submitBtnInitiate.classList.add('loading');
        submitBtnInitiate.disabled = true;
        const cartDrawer = document.querySelector('cart-drawer');
        const itemInitaite = { id: target.target.closest('.custom-product-form-xt').querySelector('[name="id"]').value, quantity: 1, }
        if (cartDrawer) cartDrawer.enableLoading();
        const bundleCart = {
          items: [itemInitaite],
          sections: cartDrawer?.getSectionsToRender()?.map(s => s.section) || [],
          sections_url: window.location.pathname
        };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(bundleCart),
          credentials: 'same-origin'
        }).then(res => res.json())
          .then(data => cartDrawer?.renderContent(data.sections))
          .catch(console.error)
          .finally(() => {
            if (cartDrawer) {
              cartDrawer.disableLoading();
              cartDrawer.open();
            }
            submitBtnInitiate.classList.remove('loading');
            submitBtnInitiate.disabled = false;
          });        

      })
    })
  }

  
  const timelineItems = document.querySelectorAll('.timeline-item');
  const progressDots = document.querySelectorAll('.progress-dot');
  const progressBar = document.getElementById('progressBar');
  const progressContainer = document.querySelector('.progress-container');

  if (progressContainer || progressBar || timelineItems.length != 0 || progressDots.length != 0){
    function debounce(func, wait = 100) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    }
    function alignDotsToItems() {
      let cumulativeHeight = 0;
      timelineItems.forEach((item, index) => {
        const itemHeight = item.offsetHeight;
        const itemStyle = window.getComputedStyle(item);
        const marginBottom = parseFloat(itemStyle.marginBottom) || 0;
        if (progressDots[index]) {
          progressDots[index].style.top = `${cumulativeHeight}px`;
        }
        cumulativeHeight += itemHeight + marginBottom;
      });
      updateProgressBarHeight();
      adjustProgressContainerHeight();
    }
  
    function updateProgressBarHeight() {
      const activeDots = Array.from(progressDots).filter(dot => dot.classList.contains('active'));
      if (activeDots.length === 0) {
        progressBar.style.height = '0px';
        return;
      }
      const firstTop = parseFloat(progressDots[0].style.top) || 0;
      const lastActiveDot = activeDots[activeDots.length - 1];
      const lastTop = parseFloat(lastActiveDot.style.top) || 0;
      progressBar.style.top = `${firstTop}px`;
      progressBar.style.height = `${lastTop - firstTop}px`;
    }
  
    function setActiveDotByScroll() {
      const viewportCenter = window.innerHeight / 2;
      let activeIndex = 0;
      let minDistance = Infinity;
      timelineItems.forEach((item, index) => {
        const rect = item.getBoundingClientRect();
        const itemMiddle = rect.top + rect.height / 2;
        const distance = Math.abs(itemMiddle - viewportCenter);
        if (distance < minDistance) {
          minDistance = distance;
          activeIndex = index;
        }
      });
      timelineItems.forEach((item, index) => {
        const isActive = index <= activeIndex;
        item.classList.toggle('center-stage', index === activeIndex);
        progressDots[index]?.classList.toggle('active', isActive);
      });
      updateProgressBarHeight();
    }
  
    function adjustProgressContainerHeight() {
      const firstDotTop = progressDots[0].offsetTop;
      const lastDot = progressDots[progressDots.length - 1];
      const lastDotTop = lastDot.offsetTop;
      const lastDotHeight = lastDot.offsetHeight;
      const lastDotStyle = window.getComputedStyle(lastDot);
      const lastDotMarginBottom = parseFloat(lastDotStyle.marginBottom) || 0;
      const height = (lastDotTop + lastDotHeight + lastDotMarginBottom) - firstDotTop;
      progressContainer.style.height = `${height}px`;
    }
    const updateLayout = () => {
      alignDotsToItems();
      setActiveDotByScroll();
    };
    const debouncedUpdate = debounce(updateLayout, 100);
    window.addEventListener('scroll', debounce(setActiveDotByScroll, 50));
    window.addEventListener('resize', debouncedUpdate);
    requestAnimationFrame(() => {
      debouncedUpdate();
      setTimeout(debouncedUpdate, 150);
    });
    const observer = new ResizeObserver(debouncedUpdate);
    timelineItems.forEach(item => observer.observe(item));
    let tries = 0;
    const maxTries = 10;
    const retryLoop = () => {
      debouncedUpdate();
      if (++tries < maxTries) {
        setTimeout(retryLoop, 300);
      }
    };
    retryLoop();
  }

  if( document.querySelectorAll('.video__playIcon').length > 0 ){
    document.querySelectorAll('.video__playIcon .action--pause').forEach((elm)=>{
      elm.addEventListener('click', (target)=>{
        target.preventDefault();
        target.currentTarget.classList.add('hidden');
        target.target.closest('.Testimonial__video_tagged').querySelector('.action--play').classList.remove('hidden');
        target.target.closest('.Testimonial__video_tagged').querySelector('video').pause();
      })
    });
    document.querySelectorAll('.video__playIcon .action--play').forEach((elm)=>{
      elm.addEventListener('click', (target)=>{
        target.preventDefault();
        target.currentTarget.classList.add('hidden');
        target.target.closest('.Testimonial__video_tagged').querySelector('.action--pause').classList.remove('hidden');
        target.target.closest('.Testimonial__video_tagged').querySelector('video').play();
      })
    });  
  }

  if( document.querySelectorAll('[js-doctor-dietitian-lightbox]').length > 0 ){
    document.querySelectorAll('[js-doctor-dietitian-lightbox]').forEach((elm)=>{
      elm.addEventListener('click',(target)=>{
        target.preventDefault();
        let lighhtbox_doctor = document.querySelector('.doctor_dietitian_lightbox_html').innerHTML;
        document.querySelector('.doctor_dietitian_lightbox').innerHTML = lighhtbox_doctor;
        document.querySelector('.doctor_dietitian_lightbox').classList.add('active');
        document.querySelector('.page-overlay').classList.add('is-visible');
        document.body.classList.add('overflow-hidden');
      })
    })   
  }
  
  class doctorDietitian extends HTMLElement{
    constructor(){
      super();
      this.querySelectorAll('[js-doctor-dietitian-lightbox-close]').forEach((elm)=>{
        elm.addEventListener('click',(target)=>{
          target.preventDefault();
          document.querySelector('.doctor_dietitian_lightbox').innerHTML = ``;
          document.querySelector('.doctor_dietitian_lightbox').classList.remove('active');
          document.querySelector('.page-overlay').classList.remove('is-visible');
          document.body.classList.remove('overflow-hidden');
        })
      })       
    }
  }
  window.customElements.define('cus-dietitian-widget',doctorDietitian);  

  function setupMarquee({ contentId, containerSelector, speed = 0.5 }) {
    const scrollingContent = document.getElementById(contentId);
    if (!scrollingContent) {
      console.warn(`Marquee setup failed: Element with ID "${contentId}" not found.`);
      return;
    }
    const container = document.querySelector(containerSelector);
    if (!container) {
      console.warn(`Marquee setup failed: Container with selector "${containerSelector}" not found.`);
      return;
    }
    scrollingContent.innerHTML += scrollingContent.innerHTML;
    let x = 0;
    let isPaused = false;
    function animate() {
      if (!isPaused) {
        x -= speed;
        if (Math.abs(x) >= scrollingContent.scrollWidth / 2) {
          x = 0;
        }
        scrollingContent.style.transform = `translateX(${x}px)`;
      }
      requestAnimationFrame(animate);
    }
    container.addEventListener("mouseenter", () => { isPaused = true; });
    container.addEventListener("mouseleave", () => { isPaused = false; });
    animate();
  }
  setupMarquee({ contentId: "scrollingContent", containerSelector: ".squeeze_scroller_main", speed: 0.5 });

  if( document.querySelectorAll('a[href*="/type__pdp_main_wrapper"]').length > 0 ){
    document.querySelectorAll('a[href*="/type__pdp_main_wrapper"]').forEach(link => {
      link.addEventListener('click', event => {
        event.preventDefault();
        const dynamicAttribute = event.target.getAttribute('href').split('/')[1];
        const targetElement = document.querySelector(`.${dynamicAttribute}`);
        const sectionHeader = document.querySelector('.section-header');
        if (!targetElement || !sectionHeader) return;
        const totalTop = sectionHeader.clientHeight;
        window.scrollTo({
          top: targetElement.offsetTop - totalTop,
          behavior: 'smooth'
        });
      });
    });
  } 

  if( document.querySelectorAll('[js-scroll-pdp-section]').length > 0 ){
    document.querySelectorAll('[js-scroll-pdp-section]').forEach(link => {
      link.addEventListener('click', event => {
        event.preventDefault();
        const targetElement = document.querySelector(`.type__pdp_main_wrapper`);
        const sectionHeader = document.querySelector('.section-header');
        if (!targetElement || !sectionHeader) return;
        const totalTop = sectionHeader.clientHeight;
        window.scrollTo({
          top: targetElement.offsetTop - totalTop,
          behavior: 'smooth'
        });
      });
    });
  } 

  if( document.querySelectorAll('.Testimonial_button_reviews').length > 0 ){
    document.querySelectorAll('.Testimonial_button_reviews').forEach((elm)=>{
      elm.addEventListener('click', (target)=>{
        target.preventDefault();
        const targetElementRv = document.querySelector(`.custom__product__widget`);
        const sectionHeaderRv = document.querySelector('.section-header');
        if (!targetElementRv || !sectionHeaderRv) return;
        const totalTopRv = sectionHeaderRv.clientHeight;
        window.scrollTo({
          top: targetElementRv.offsetTop - totalTopRv,
          behavior: 'smooth'
        });        
      })
    })
  }  

function isInViewport(elem) {
    const rect = elem.getBoundingClientRect();
    return (
      rect.bottom >= 0 &&
      rect.right >= 0 &&
      rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
  
  const stickyBar = document.querySelector('.rainforest__sticky_button_actions');
  const header = document.querySelector('.section-header');
  const headerHeight = header ? header.clientHeight : 0;
  const addToCartElements = document.querySelectorAll('[js-scroll-identity]');
  const footerSections = document.querySelectorAll('.footer__main_wrapper');
  const recentlyViewedSections = document.querySelectorAll('[section="product-recently-viewed"]');
  
  function shouldHideSticky() {
    for (const el of [...addToCartElements, ...footerSections, ...recentlyViewedSections]) {
      if (el && isInViewport(el)) return true;
    }
    return false;
  }
  
  function handleStickyScroll() {
    const scrollY = window.scrollY;
    const triggerElement = document.querySelector('[js-scroll-identity]');
    if (!triggerElement || !stickyBar) return;
    const triggerOffset = triggerElement.offsetTop;
    if (scrollY > triggerOffset) {
      if (shouldHideSticky()) {
        stickyBar.classList.remove('stickyAddToCart');
        stickyBar.style.top = `-100%`;
      } else {
        stickyBar.classList.add('stickyAddToCart');
        stickyBar.style.top = `${headerHeight}px`;
      }
    } else {
      stickyBar.classList.remove('stickyAddToCart');
      stickyBar.style.top = `-100%`;
    }
  }
  window.addEventListener('scroll', handleStickyScroll, { passive: true });

  const stickyButton = document.querySelector('.rainforest__sticky_button_actions .rainforest__buttonScroll');
  const scrollTarget = document.querySelector('cus-selection-variants');
  if (stickyButton && header && scrollTarget) {
    stickyButton.addEventListener('click', (e) => {
      e.preventDefault();
      const offset = scrollTarget.offsetTop - header.clientHeight;
      window.scrollTo({
        top: offset,
        behavior: 'smooth'
      });
    });
  }
    
  // const stickyFormContainer = document?.querySelector('.rainforest__sticky_button_actions');
  // const productForm = document?.querySelector('cus-selection-variants');
  // const cartDrawerSticky = document?.querySelector('cart-drawer');
  // if (stickyFormContainer && productForm) {
  //   const submitBtn = stickyFormContainer.querySelector('.product-form__submit');
  //   submitBtn?.addEventListener('click', (e) => {
  //     e.preventDefault();
  //     const isOneTime = document.querySelector('.purchaseOnetime_layoutWidget')?.classList.contains('active');
  //     const variantId = productForm.querySelector('[name="id"]')?.value;
  //     const sellingPlanId = productForm.querySelector('[name="selling_plan_id"]')?.value;
  //     if (!variantId) return;
  //     submitBtn.classList.add('loading');
  //     submitBtn.disabled = true;
  //     const item = { id: variantId, quantity: 1 };
  //     if (!isOneTime && sellingPlanId) item.selling_plan = sellingPlanId;
  //     const bundleCart = {
  //       items: [item],
  //       sections: cartDrawerSticky?.getSectionsToRender()?.map(section => section.section) || [],
  //       sections_url: window.location.pathname
  //     };
  //     cartDrawerSticky?.enableLoading();
  //     fetch('/cart/add.js', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'X-Requested-With': 'XMLHttpRequest'
  //       },
  //       body: JSON.stringify(bundleCart),
  //       credentials: 'same-origin'
  //     })
  //     .then(response => response.json())
  //     .then(parsedState => {
  //       cartDrawerSticky?.renderContent(parsedState.sections);
  //     })
  //     .catch(console.error)
  //     .finally(() => {
  //       cartDrawerSticky?.disableLoading();
  //       cartDrawerSticky?.open();
  //       submitBtn.classList.remove('loading');
  //       submitBtn.disabled = false;
  //     });
  //   });
  // }  
  
})